import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider, useAuth } from './auth'
import { ConfirmDialogProvider } from './components/ui/ConfirmDialog'
import { queryClient } from './lib/queryClient'
import { AgilePage } from './pages/AgilePage'
import { ClientCommitmentsPage } from './pages/ClientCommitmentsPage'
import { ClientsPage } from './pages/ClientsPage'
import { DashboardPage } from './pages/DashboardPage'
import { InvoicesPage } from './pages/InvoicesPage'
import { LeadsPage } from './pages/LeadsPage'
import { LoginPage } from './pages/LoginPage'
import { PatternsPage } from './pages/PatternsPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ProposalModulesPage } from './pages/ProposalModulesPage'
import { ProposalsPage } from './pages/ProposalsPage'
import { PublicProposalPage } from './pages/PublicProposalPage'
import { SetupPage } from './pages/SetupPage'
import { TeamPage } from './pages/TeamPage'
import { TenantSettingsPage } from './pages/TenantSettingsPage'
import { TimePage } from './pages/TimePage'
import { WorkflowsPage } from './pages/WorkflowsPage'
import { RouterProvider, useRoute } from './router'

function Routes() {
  const { status } = useAuth()
  const route = useRoute()
  const path = route.path

  // Public routes — no auth required. Must match BEFORE the auth gate.
  if (path.startsWith('/p/')) {
    const token = path.slice('/p/'.length).split('/')[0] ?? ''
    return <PublicProposalPage token={token} />
  }

  if (status === 'loading') {
    return (
      <div className="min-h-screen grid place-items-center text-zinc-400">
        <div className="text-sm">Caricamento…</div>
      </div>
    )
  }
  if (status !== 'authenticated') return <LoginPage />

  if (path === '/' || path === '/dashboard') return <DashboardPage />
  if (path.startsWith('/clients')) return <ClientsPage />
  if (path.startsWith('/projects')) return <ProjectsPage />
  if (path.startsWith('/agile')) return <AgilePage />
  if (path.startsWith('/time')) return <TimePage />
  if (path.startsWith('/leads')) return <LeadsPage />
  if (path.startsWith('/invoices')) return <InvoicesPage />
  if (path.startsWith('/scadenziario')) return <ClientCommitmentsPage />
  if (path.startsWith('/proposal-modules')) return <ProposalModulesPage />
  if (path.startsWith('/proposals')) return <ProposalsPage />
  if (path.startsWith('/patterns')) return <PatternsPage />
  if (path.startsWith('/workflows')) return <WorkflowsPage />
  if (path.startsWith('/team')) return <TeamPage />
  if (path.startsWith('/settings/tenant')) return <TenantSettingsPage />
  if (path.startsWith('/setup')) return <SetupPage />

  return <DashboardPage />
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider>
          <ConfirmDialogProvider>
            <Routes />
          </ConfirmDialogProvider>
        </RouterProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
